import { Resource } from "react-admin";
import { Playground } from "../playground/Playground";

export const playgroundResource = <Resource key="playground" name="playground" edit={Playground} />;
